<template>
  <a-modal
    :visible="visible"
    :width="692"
    centered
    :footer="null"
    :closable="false"
    wrapClassName="resultReminder"
    :maskClosable="false"
  >
    <div class="header">
      <auth-img class="icon" :src="data?.appointResult ? success : fail" alt="" />
      <span class="title">{{ `${titleMap.get(data?.appointResult)}` }}</span>
    </div>
    <div class="content">
      <div v-for="(item, index) in verifyContent" class="item" :key="index">
        <span :class="`label ${(index + 1) % 2 === 0 ? 'borderLeft' : null}`">
          {{ `${item.label}：` }}
        </span>
        <span class="val">{{ item.value }}</span>
      </div>
    </div>
    <div :class="`tips ${data?.appointResult ? 'success' : 'error'}`">
      <div v-if="!data?.appointResult">失败原因：</div>
      <div v-else class="intro">预约须知：</div>
      <div class="introText">
        {{ data?.appointResult ? data?.blacklistContent : data?.appointMessage }}
      </div>
    </div>
    <div class="footer">
      <a-button type="primary" @click="handleOk">确定</a-button>
    </div>
  </a-modal>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue'
import success from '@/assets/img/register/success.png'
import fail from '@/assets/img/register/fail.png'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  data: {
    type: Object,
    default: () => ({})
  }
})
const emit = defineEmits(['handleOk'])
const titleMap = new Map([
  [false, '预约失败，请重试！'],
  [true, '预约成功，请提醒患者及时就诊！']
])
const verifyContent = computed(() => [
  { label: '患者姓名', value: props.data.patientName },
  { label: '就诊时间', value: props.data.visitTime },
  { label: '医生姓名', value: props.data.doctorName },
  { label: '就诊序号', value: props.data.reserveNum },
  { label: '就诊医院', value: props.data.hospitalName },
  { label: '就诊地点', value: props.data.visitLocation },
  { label: '就诊科室', value: props.data.departmentName },
  { label: '取号密码', value: props.data.appointmentTicketNumber }
])

const handleOk = () => {
  emit('handleOk')
}
</script>

<style scoped lang="scss">
.resultReminder {
  padding: 24px;
  .header {
    font-size: 20px;
    color: #262626;
    text-align: center;
    margin-bottom: 24px;
    .icon {
      display: inline-block;
      width: 32px;
      height: 32px;
      margin-right: 12px;
      margin-bottom: 2px;
    }
    .title {
      font-size: 20px;
      color: #262626;
    }
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 20px;
    .item {
      width: 50%;
      padding: 15px 0;
      font-size: 14px;
      font-weight: 500;
      text-align: left;
      border-bottom: 1px solid #e8e8e8;
      .label {
        color: #999999;
        padding-left: 13px;
      }
      .val {
        color: #333333;
      }
      .borderLeft {
        border-left: 1px solid #e8e8e8;
      }
    }
  }
  .tips {
    padding: 16px 24px 16px 20px;
    line-height: 24px;
    font-weight: 500;
    font-size: 14px;
    .intro {
      color: #595959;
      font-size: 14px;
      font-weight: 700;
    }
    .introText {
      white-space: pre-wrap;
    }
  }
  .error {
    background-color: #fef2f0;
    color: #ff4848;
  }
  .success {
    background-color: #fafafa;
    color: #595959;
    font-weight: 400;
  }
  .footer {
    margin-top: 24px;
    text-align: center;
    button {
      width: 80px;
      height: 32px;
      border-radius: 4px;
    }
  }
}
</style>
